import { Link } from "react-router-dom";
import STBoardDetail from "../../../assets/styles/organisms/boardDetail.module.scss";
import { useBoard } from "../../../providers/BoardDetailProvider";

const BoardCategoryInformation = () => {
  const {
    state: { boardDetailData },
  } = useBoard();
  const {
    category_title = "",
    category_description = "",
    board_category_id,
  } = boardDetailData ?? {};
  return (
    <div className={`${STBoardDetail.category} ${STBoardDetail.wrapper}`}>
      <Link
        to={`/message-board/categories/${board_category_id}`}
        className={STBoardDetail.categoryTitle}
      >
        {category_title}
      </Link>
      <p className={STBoardDetail.categoryDescription}>
        {category_description}
      </p>
    </div>
  );
};

export default BoardCategoryInformation;
